import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const AndroidDetail = () => {
    return (
        <>
            {/* Career Detail Banner */}
            <section className='about-page'>
                <div className='about-bg'>
                    <div className='c-detail-shap-1 con-shap-c'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='about-shap-3'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 con-shap-c'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <div className='career-shap-22'>
                        <img src="../assets/images/whi-3.svg" alt="" />
                    </div>
                    <Container>
                        <Row className='align-items-center'>
                            <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                                <div className='career-img text-center'>
                                    <img src="../assets/images/android-banner.png" alt="" />
                                </div>
                                <div className='career-shap-1'>
                                    <img src="../assets/images/white-arr.svg" alt="" />
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                                <div className='tech-content'>
                                    <h2>Android Developer </h2>
                                    <p>As an Android Developer at IMUII, you’ll play a key role in building innovative mobile applications tailored for the Android ecosystem.   </p>
                                    <div className='interest-btn'>
                                        <Link to='/career-form'>
                                            <button className='job-btn'>I’m Interested</button>
                                        </Link>
                                        <Link to='/career-form'>
                                            <button className='friend-btn'>Refer A Friend</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </div>
            </section>
    
            {/* Information Section */}
            <section className='information-section'>
                <Container>
                    <Row>
                        <div className="col-md-6 mb-30" data-aos="fade-up-right" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Job Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-1.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Region</p>
                                                <h5>Tamil Nadu</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                       <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-2.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Industry</p>
                                                <h5>Technology</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                         <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/android-career.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Role</p>
                                                <h5>Android Developer</h5>
                                            </div>
                                        </Box>
                                        
                                    </div>
                                </Row>
                            </div>
                        </div>
                        <div className="col-md-6 mb-30" data-aos="fade-up-left" data-aos-duration="2000">
                            <div className="information-card">
                                <h3>Other Information</h3>
                                <Row>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-4.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Education</p>
                                                <h5>UG / PG</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                       <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-5.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Passed Out</p>
                                                <h5>2019</h5>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}>
                                            <div className='information-icon'>
                                                <img src="../assets/images/c-detail-6.svg" alt="" />
                                            </div>
                                            <div className='information-text'>
                                                <p>Salary Range</p>
                                                <h5>₹ 3 to 7 LPA</h5>
                                            </div>
                                        </Box>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
    
            {/* Job Description Section */}
            <section className='job-description-section'>
                <Container>
                    <div className='job-description' data-aos="fade-right" data-aos-duration="2000">
                        <h3>Job Description</h3>
                        <p> You’ll work closely with product designers, backend engineers, and QA teams to bring seamless, high-performance user experiences to life. This role demands proficiency in Kotlin and Java, a strong grasp of Android SDK components, and familiarity with modern architecture patterns like MVVM or Clean Architecture.  </p>
                        <p> You’ll also be responsible for integrating APIs, managing app releases, and ensuring app performance across devices and OS versions.From prototyping features to publishing on the Play Store, you’ll own the development lifecycle end-to-end. You'll be expected to write clean, maintainable code and address performance bottlenecks. </p>
                        <p>The role also involves debugging issues, implementing UI/UX guidelines, and keeping up with the latest Android trends and tools.  If you’re someone who thrives on turning ideas into interactive, efficient mobile experiences—and has an eye for detail—we’d love to see you in action. At IMUII, your code won’t just work—it’ll wow. </p>
                    </div>
                </Container>
            </section>
    
            {/* Key Responsibility Section */}
            <section className='key-responsibility-section'>
                <Container>
                    <div className='key-responsibility' data-aos="fade-left" data-aos-duration="2000">
                        <h3>Key Responsibility</h3>
                        <ul>
                            <li>
                                <p>Build and maintain Android applications using Kotlin, Java, and modern architecture patterns. </p>
                            </li>
                            <li>
                                <p>Collaborate with UX/UI designers to implement visually consistent and responsive layouts. </p>
                            </li>
                            <li>
                                <p>Integrate RESTful APIs and third-party SDKs securely and efficiently.  </p>
                            </li>
                            <li>
                                <p>Optimize app performance for various Android devices and screen sizes.  </p>
                            </li>
                            <li>
                                <p>Ensure backward compatibility with legacy Android OS versions. </p>
                            </li>
                            <li>
                                <p>Debug, test, and fix app issues reported during QA or by end-users. </p>
                            </li>
                            <li>
                                <p>Manage app releases, updates, and Play Store submissions end-to-end. </p>
                            </li>
                            <li>
                                <p>Follow clean code practices and contribute to regular peer code reviews.  </p>
                            </li>
                            <li>
                                <p>Stay updated with Android platform changes and advocate for best practices.  </p>
                            </li>
                        </ul>
                    </div>
    
                    <div className='btn-margin' data-aos="zoom-in" data-aos-duration="2000">
                        <Link to='/career-form'>
                            <button className='interested-btn'>I’m Interested</button>
                        </Link>
                    </div>
                </Container>
            </section>
            
        </>
    )
}

export default AndroidDetail